var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconworkflowy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_996_70957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 6.23968 0 4.55953 0.653961 3.27606C1.2292 2.14708 2.14708 1.2292 3.27606 0.653961C4.55953 0 6.23969 0 9.6 0H26.4C29.7603 0 31.4405 0 32.7239 0.653961C33.8529 1.2292 34.7708 2.14708 35.346 3.27606C36 4.55953 36 6.23969 36 9.6V26.4C36 29.7603 36 31.4405 35.346 32.7239C34.7708 33.8529 33.8529 34.7708 32.7239 35.346C31.4405 36 29.7603 36 26.4 36H9.6C6.23968 36 4.55953 36 3.27606 35.346C2.14708 34.7708 1.2292 33.8529 0.653961 32.7239C0 31.4405 0 29.7603 0 26.4V9.6Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8732 13.2472C13.4117 13.9224 12.6355 14.3655 11.7559 14.3655C11.3366 14.3655 10.9407 14.2648 10.5913 14.0862L13.9852 17.4801C14.2763 16.3844 15.275 15.577 16.4623 15.577C17.3419 15.577 18.118 16.0202 18.5796 16.6954H25.5022C26.3 16.6954 26.9468 17.3421 26.9468 18.1399C26.9468 18.9377 26.3 19.5844 25.5022 19.5844H18.5796C18.118 20.2596 17.3419 20.7028 16.4623 20.7028C16.0788 20.7028 15.715 20.6186 15.3883 20.4676L17.9534 23.0327H25.5022C26.3 23.0327 26.9468 23.6794 26.9468 24.4772C26.9468 25.275 26.3 25.9217 25.5022 25.9217H13.8732C13.4117 26.5969 12.6355 27.0401 11.7559 27.0401C11.3219 27.0401 10.9131 26.9322 10.5548 26.7418L17.8273 36.0001H30.3484C32.2271 36.0001 32.0625 36.0001 36 36.0001V20.2501L26.3876 10.6377L26.362 10.6417C26.7168 10.9049 26.9468 11.3269 26.9468 11.8026C26.9468 12.6004 26.3 13.2472 25.5022 13.2472H13.8732Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0784,
    y: 23.0322,
    width: 16.8683,
    height: 2.88905,
    rx: 1.44453,
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3188,
    y: 16.6953,
    width: 12.628,
    height: 2.88905,
    rx: 1.44453,
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0784,
    y: 10.3584,
    width: 16.8683,
    height: 2.88905,
    rx: 1.44453,
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8732 13.2473C14.1543 12.836 14.3188 12.3386 14.3188 11.8028C14.3188 11.2935 14.1702 10.8189 13.914 10.4199L16.835 13.2473H13.8732Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5796 19.5842C18.8607 19.1729 19.0252 18.6755 19.0252 18.1396C19.0252 17.6761 18.9021 17.2414 18.6869 16.8662L21.4948 19.5842H18.5796Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8732 25.9212C14.1543 25.5099 14.3188 25.0125 14.3188 24.4766C14.3188 23.9673 14.1702 23.4927 13.914 23.0938L16.835 25.9212H13.8732Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7559,
    cy: 11.8021,
    rx: 2.56287,
    ry: 2.56287,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.4623,
    cy: 18.14,
    r: 2.56287,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7559,
    cy: 24.4769,
    rx: 2.56287,
    ry: 2.56287,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_996_70957"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 6.23968 0 4.55953 0.653961 3.27606C1.2292 2.14708 2.14708 1.2292 3.27606 0.653961C4.55953 0 6.23969 0 9.6 0H26.4C29.7603 0 31.4405 0 32.7239 0.653961C33.8529 1.2292 34.7708 2.14708 35.346 3.27606C36 4.55953 36 6.23969 36 9.6V26.4C36 29.7603 36 31.4405 35.346 32.7239C34.7708 33.8529 33.8529 34.7708 32.7239 35.346C31.4405 36 29.7603 36 26.4 36H9.6C6.23968 36 4.55953 36 3.27606 35.346C2.14708 34.7708 1.2292 33.8529 0.653961 32.7239C0 31.4405 0 29.7603 0 26.4V9.6Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconworkflowy);
export default __webpack_public_path__ + "static/media/iconworkflowy.fdcdd787b0c156164bb079e88527eac7.svg";
export { ForwardRef as ReactComponent };